import { render, staticRenderFns } from "./DeleteBook.vue?vue&type=template&id=0f3e7a65"
import script from "./DeleteBook.vue?vue&type=script&lang=js"
export * from "./DeleteBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports